import App from './App.svelte';

const socket = io(__APIURL__);
const token = localStorage.getItem("token");

socket.emit("controlauth", token === null ? "" : token);

socket.on("borrarToken" , () => {
	localStorage.removeItem("token");
	window.location.reload();
});

const app = new App({
	target: document.body
});

export default app;